<template>
  <div class="tnc__wrapper">
    <div class="tnc__content">
      <a @click="$emit('closeTnc')" class="link tnc__close"
        ><Icons name="close"
      /></a>
      <div class="tnc__desc">
        <h1 class="tnc__title txt-upper fw-bold" v-html="$t('tnc.title')"></h1>
        <div v-html="$t('tnc.desc')"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icons } from "~/components/";

export default {
  name: "TNC",
  components: { Icons },
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";
.content .app {
  .tnc {
    &__wrapper {
      position: fixed;
      z-index: 100;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      top: 0;
      left: 0;
      padding: rem(20);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 3000;
    }

    &__title {
      font-size: rem(40);
      letter-spacing: 0.2em;
      margin-bottom: rem(24);
      text-align: center;
      line-height: 1.2em;

      @include media-breakpoint-down(md) {
        font-size: rem(32);
      }
    }

    &__close {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 45px;
      right: 30px;
      aspect-ratio: 1;
      position: absolute;

      @include media-breakpoint-down(md) {
        top: 10px;
        right: 10px;
      }

      img {
        width: 50%;
        height: 50%;
        object-fit: contain;
      }
    }

    &__desc {
      overflow-y: auto;
      max-width: rem(989);
      margin-left: auto;
      margin-right: auto;
    }

    &__content {
      position: relative;
      background-color: color(whiteAbs);
      width: 100%;
      max-height: 100%;
      max-width: rem(1192);
      display: flex;
      padding: rem(80) rem(20);

      @include media-breakpoint-down(md) {
        padding: rem(35) rem(20);
        padding-top: rem(50);
      }

      p,
      li {
        font-size: rem(20);
        line-height: 1.2em;

        @include media-breakpoint-down(md) {
          font-size: rem(16);
        }
      }

      ol {
        list-style: decimal;
        padding-left: rem(6);
      }

      li {
        margin-bottom: 0.2em;
        margin-left: 1em;
      }

      h3 {
        font-size: rem(24);
        margin-bottom: rem(16);
        letter-spacing: 0.2em;

        @include media-breakpoint-down(md) {
          font-size: rem(16);
        }
      }

      p {
        margin-bottom: rem(24);
      }
    }
  }
}
</style>
